export default __webpack_public_path__ + "static/media/users.a76a1653.svg";